import { FormEvent, useState } from 'react';
import { AxiosError } from 'axios';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { hasAuthToken, setAuthToken } from '../auth/token';

type LoginResponse = {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
  };
};

type LocationState = {
  from?: {
    pathname?: string;
  };
};

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  if (hasAuthToken()) {
    return <Navigate to="/projects" replace />;
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage(null);

    try {
      const response = await apiClient.post<LoginResponse>('/auth/login', {
        email,
        password,
      });

      setAuthToken(response.data.token);

      const state = location.state as LocationState | null;
      const nextPath = state?.from?.pathname || '/projects';
      navigate(nextPath, { replace: true });
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 401) {
        setErrorMessage('Неверный email или пароль.');
      } else {
        setErrorMessage('Не удалось выполнить вход. Попробуйте ещё раз.');
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: '360px',
          padding: '24px',
          border: '1px solid #e5e7eb',
          borderRadius: '12px',
          background: '#fff',
          boxSizing: 'border-box',
        }}
      >
        <h1 style={{ marginTop: 0 }}>Вход</h1>
        <p>Введите email и пароль, чтобы перейти к проектам.</p>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '12px' }}>
          <label style={{ display: 'grid', gap: '6px' }}>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
              placeholder="you@mail.com"
            />
          </label>

          <label style={{ display: 'grid', gap: '6px' }}>
            Пароль
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              autoComplete="current-password"
              placeholder="Введите пароль"
            />
          </label>

          {errorMessage ? (
            <p role="alert" style={{ color: '#b91c1c', margin: 0 }}>
              {errorMessage}
            </p>
          ) : null}

          <button type="submit" className="btn" disabled={isLoading}>
            {isLoading ? 'Входим...' : 'Войти'}
          </button>
        </form>
      </section>
    </main>
  );
}
